/* eslint-disable no-undef */
export default function createCssClass(className, styles) {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = `${className} {${styles}  }`;
  document.getElementsByTagName('head')[0].appendChild(style);
}
